// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"1dba5a61","232":"a8961258","684":"af74f586"}[chunkId] + ".chunk.js";
};